import axios from 'axios';

export const BCCService = {
  async getPersonInfoByIIN(iin) {
    if (!iin) {
      return;
    }

    const res = await axios.get(`org/v1/taxPayerInfo/?iin=${iin}`);

    if (res.status === 200) {
      return res.data?.detail;
    }

    return Promise.reject();
  },
};
